import Media from './Media';

// Style guide
const theme = {
    colors: {
        negative: '#FFFFFF',
        disabled: '#F2F2F2',
        lines: '#E0E0E0',
        input: '#CBCBCB',
        inputText: '#666666',
        text: '#1F1F1F',
        bgLight: '#F2FAF4',
        bg: '#D7F2DC',
        bgDark: '#C7EBCE',
        button: '#439758',
        link: '#2E8142',
        danger: '#FC514A',
        tooltip: '#F7FBB3'
    },

    spacing: {
        blockXL: '200px',
        blockL: '160px',
        blockM: '140px',
        blockS: '120px',
        blockXS: '100px',
    
        elementXL: '90px',
        elementL: '80px',
        elementM: '70px',
        elementS: '60px',
        elementXS: '50px',
    
        contentXL: '40px',
        contentL: '30px',
        contentM: '20px',
        contentS: '16px',
        contentXS: '10px'
    },

    fonts: {
        h1: () => `
            ${Media.greaterThan('l')`
                line-height: 5.875vw;
            `.join('')}
            ${Media.greaterThan('m')`
                font-size: 5vw;
                line-height: 6.166666666666667vw;
            `.join('')}
            ${Media.lessThan('s')`
                font-size: 32px;
                line-height: 38px;
            `.join('')}
            ${Media.lessThan('xs')`
                font-size: 32px;
                line-height: 38px;
            `.join('')},
        `,
    
        h2: () => `
            font-family: 'Untitled', sans-serif;
            font-size: 45px;
            line-height: 59px;
    
            ${Media.lessThan('s')`
                font-size: 26px;
                line-height: 38px;
            `.join('')}
        `,
    
        h3: () => `
            font-family: 'Untitled', sans-serif;
            font-size: 26px;
            line-height: 38px;
    
            ${Media.lessThan('m')`
                font-size: 18px;
            `.join('')}
        `,
    
        h4: () => `
            font-family: 'Untitled', sans-serif;
            font-size: 22px;
            line-height: 34px;
    
            ${Media.lessThan('s')`
                font-size: 18px;
                line-height: 27px;
            `.join('')}
        `,
    
        h5: () => `
            font-family: 'Untitled', sans-serif;
            font-size: 20px;
            line-height: 26px;
    
            ${Media.lessThan('s')`
            `.join('')}
        `,
    
        h6: () => `
        font-family: 'Untitled', sans-serif;
        font-size: 18px;
        line-height: 27px;

        ${Media.lessThan('s')`
            font-size: 16px;
            line-height: 33px;
        `.join('')}
        `,
    
        p: () => `
            font-family: 'Untitled', sans-serif;
            font-size: 18px;
            line-height: 27px;
    
            ${Media.lessThan('m')`
                font-size: 16px;
                line-height: 24px;
            `.join('')}
        `
    }
}

export default theme;